import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconKeyLargeComponent } from "./med-icon-key-large.component";

@NgModule({
  declarations: [
    MedIconKeyLargeComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconKeyLargeComponent,
  ],
})
export class MedIconKeyLargeModule { }
